import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import axios from 'axios';
export default function upload(option) {
  var formData = new FormData();
  if (option.data) {
    Object.keys(option.data).map(function (key) {
      formData.append(key, option.data[key]);
    });
  }
  var fileName = option.filename;
  formData.append(option.name || 'file', option.file, fileName);
  option.onStart && option.onStart();
  axios({
    method: option.action,
    url: option.target,
    headers: option.headers,
    data: formData,
    onUploadProgress: option.onProgress
  }).then(function (res) {
    return option.onEnd(res);
  }).catch(function (e) {
    option.onEnd(e);
  });
}